import { APICfg } from 'services/api/api'
import {
  findMultipleFacets,
  findSingleFacet,
  bundleFacetIds,
} from 'ui-shared/Facets'
import { experienceParse, experienceWrite } from '../experience'
import { parseFacet } from '../facets'
import { PhysicalExperienceToAPI } from './types/api/request-models'
import { APIPhysicalExperience } from './types/api/response-models'
import { PhysicalExperience } from './types/internal/physical-models'

// ============
// PARSE
// ============

const physicalParse = (res: APIPhysicalExperience): PhysicalExperience => {
  const { minDuration, maxDuration } = res
  const facets = res.facets.map(parseFacet)
  const settingFacets = findMultipleFacets(facets, 'productFilter', 'Setting')
  const languageFacets = findMultipleFacets(facets, 'productFilter', 'Language')

  const teambuildingCategoryFacet = findSingleFacet(
    facets,
    'productFilter',
    'TeamBuildingCategory'
  )

  return {
    ...experienceParse(res),
    settingFacets,
    languageFacets,
    teambuildingCategoryFacet,
    minDuration,
    maxDuration,
  }
}

// ============
// WRITE
// ============

const physicalWrite = async (
  req: PhysicalExperience
): Promise<PhysicalExperienceToAPI> => {
  const {
    teambuildingCategoryFacet,
    settingFacets = [],
    languageFacets = [],
    minDuration,
    maxDuration,
    ...reqRest
  } = req
  const { facets, ...mappedRest } = await experienceWrite(reqRest)

  return {
    ...mappedRest,
    facets: bundleFacetIds(
      ...facets,
      teambuildingCategoryFacet === '' ? null : teambuildingCategoryFacet,
      ...settingFacets,
      ...languageFacets
    ),
    minDuration,
    maxDuration,
  }
}

// ============
// CFG
// ============

const apiCfg: APICfg = {
  endpoint: 'physicalexperiences',
  parse: physicalParse,
  write: physicalWrite,
}

export default apiCfg
